import React from "react";
import { ChatKit, useChatKit } from "@openai/chatkit-react";

export function MyChat() {
  const { control } = useChatKit({
    api: {
      async getClientSecret(existing) {
	  // --- THIS IS THE NEW LINE ---
	    const userId = Math.random().toString(); // Create a random number and convert it to a string
	    // --------------------------

        // Call your backend endpoint to get client_secret
        const res = await fetch("https://cbcheck.hrmthread.com/api/chatkit/session", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
	   body: JSON.stringify({user_id:userId}),
        });
        const { client_secret } = await res.json();
        return client_secret;
      },
    },
  });

const chatStyle = {
  width: '100%',
  maxWidth: '600px',
  // The height will now be controlled by CSS for flexibility
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
};

// Add a wrapper div with a class name around the ChatKit component
return (
  <div className="ChatKitContainer">
    <ChatKit control={control} style={chatStyle} />
  </div>
);

}
